import "./style.scss";

import Vue from 'vue'
const routes = [];

const RouterView = { render (c) { return c('router-view') } };

import Flatpay from "./flatpay";
import FlatpayPayouts from "./flatpayReports";

routes.push({ path: "flatpay", component: RouterView, meta: { label: "Flatpay" }, children: [
    { path: "", component: Flatpay, name: "flatpay", meta: { module: "flatpay" } },
    { path: "reports", component: FlatpayPayouts, name: "flatpayReports", meta: { module: "flatpay" } },
] });

export { routes };
